import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import FieldKit from 'field-kit';

export default class TextField extends React.Component {
  constructor(props) {
    super(props);

    this.buildFieldKitField = this.buildFieldKitField.bind(this);
    this.setUpPlaceholders = this.setUpPlaceholders.bind(this);
    this.setupEvents = this.setupEvents.bind(this);
    this.getField = this.getField.bind(this);
    this.getFormatter = this.getFormatter.bind(this);
    this.getElement = this.getElement.bind(this);
    this.getValue = this.getValue.bind(this);
    this.onTextDidChange = this.onTextDidChange.bind(this);

    this.state = {
      value: props.value,
      formattedValue: ''
    };

    this.name = props.name;
  }

  componentDidMount() {
    this.buildFieldKitField();
    this.field.setValue(this.props.value);
    this.value = this.props.value;

    this.setUpPlaceholders();

    this.setupEvents();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== undefined && this.state.value !== nextProps.value) {
      this.field.setValue(nextProps.value);
    }
  }

  buildFieldKitField() {
    const field = this.getField();

    if (field) {
      this.field = field;
    } else {
      const formatter = this.getFormatter();
      if (formatter) {
        this.field = new FieldKit.TextField(this.getElement(), formatter);
      } else {
        this.field = new FieldKit.TextField(this.getElement());
      }
    }

    return this.field;
  }

  setUpPlaceholders() {
    if (this.props.placeholder || this.props.unfocusedPlaceholder) {
      this.field.setUnfocusedPlaceholder(this.props.placeholder || this.props.unfocusedPlaceholder);
    }

    if (this.props.focusedPlaceholder) {
      this.field.setFocusedPlaceholder(this.props.focusedPlaceholder);
    }
  }

  setupEvents() {
    this.field.setDelegate({
      textFieldDidBeginEditing: this.props.didBeginEditing,
      textFieldDidEndEditing: this.props.didEndEditing,
      textDidChange: this.onTextDidChange
    });
  }

  getField() {
    // Allows subclasses to override
    return null;
  }

  getFormatter() {
    // Allows subclasses to override
    return null;
  }

  getElement() {
    return ReactDOM.findDOMNode(this);
  }

  getValue() {
    return(this.state.value);
  }

  onTextDidChange(field) {
    // Update component value
    //this.props.rawValue = field.value();

    this.setState({
      value: field.value(),
      formattedValue: field.text()
    });

    // For accessing with ref
    this.value = field.value();

    if (this.props.onChange) {
      let event = {};
      event.target = {
        name: this.props.name,
        value: this.value
      };
      this.props.onChange(event);
    }
  }

  render() {
    return (
      <input
        type="text"
        name={this.props.name}
        className={this.props.className}
        onBlur={this.props.onBlur.bind(this)}
        onKeyDown={this.props.onKeyDown}
      />
    );
  }

  // Helper method for subclasses
  static getBasePropTypes() {
    return {
      rawValue: PropTypes.string,
      value: PropTypes.string,
      placeholder: PropTypes.string,
      focusedPlaceholder: PropTypes.string,
      unfocusedPlaceholder: PropTypes.string,
      onChange: PropTypes.func,
      didBeginEditing: PropTypes.func,
      didEndEditing: PropTypes.func,
      onBlur: PropTypes.func,
      onKeyDown: PropTypes.func
    }
  }

  // Helper method for subclasses
  static getBaseDefaultProps() {
    return {
      onBlur: () => {},
      didBeginEditing: () => {},
      didEndEditing: () => {}
    }
  }
}

TextField.propTypes = TextField.getBasePropTypes();

TextField.defaultProps = TextField.getBaseDefaultProps();



/** WEBPACK FOOTER **
 ** ./src/components/FieldKit/TextField.jsx
 **/